/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCalendar = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.001 1v2H15V1h2.001v2H23v20H1V3h6.001V1zm-6 4L3 21h18V5h-3.999v1.999H15V5H9.001v1.999h-2V5zm4 10v2H5v-2zm3 0v2H8v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zM7 12v2H5v-2zm3 0v2H8v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zm3 0v2h-2v-2zM7 9v2H5V9zm3 0v2H8V9zm3 0v2h-2V9zm3 0v2h-2V9zm3 0v2h-2V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCalendar as Calendar };
